import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          {/* Image */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none img-container">
            <img
              src={aboutData.image}
              alt="香蕉漫画网 - 舒适的漫画阅读空间"
              className="w-full h-auto rounded-2xl object-cover"
              onError={(e) => {
                const container = e.currentTarget.closest('.img-container');
                if (container) container.classList.add('hidden');
              }}
            />
          </div>

          {/* Content */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-3">
              <i className="ri-building-line"></i>
              <span>品牌故事</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 md:mb-5">
              {aboutData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-8">
              {aboutData.description}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              {aboutData.stats.map((stat, idx) => (
                <div key={idx} className="text-center p-3 md:p-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-xl md:text-2xl font-bold text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}